import PreferencesHitPointConfirmPane from './PreferencesOptionalClassFeaturesConfirmPane';

export default PreferencesHitPointConfirmPane;
export { PreferencesHitPointConfirmPane };
